import { useTranslation } from "react-i18next"

import type { HostedAgentWizardTab } from "../utils/hosted-agents"

import { TabsList, TabsTrigger } from "@/components/ui/tabs"

import { HOSTED_AGENT_STEPS } from "../utils/hosted-agent-setup"

/** Five understandable stages; technical controls remain available in Advanced. */
export function HostedAgentEditTabsList({
  activeTab,
  onSelect,
}: {
  activeTab: HostedAgentWizardTab
  onSelect: (tab: HostedAgentWizardTab) => void
}) {
  const { t } = useTranslation()
  const selected =
    HOSTED_AGENT_STEPS.find((step) => step.tabs.includes(activeTab)) ?? HOSTED_AGENT_STEPS[0]
  return (
    <div className="flex-shrink-0 space-y-2">
      <nav
        aria-label={t("adminDashboard.hostedAgents.product.setup")}
        className="grid grid-cols-3 gap-1 sm:grid-cols-6"
      >
        {HOSTED_AGENT_STEPS.map((step, index) => (
          <button
            key={step.id}
            aria-current={selected.id === step.id ? "step" : undefined}
            className="aria-[current=step]:border-primary aria-[current=step]:bg-accent focus-visible:ring-ring min-h-11 rounded-md border px-2 py-2 text-xs font-medium focus-visible:ring-2"
            type="button"
            onClick={() => onSelect(step.tabs[0])}
          >
            {index < 5 && <span className="text-muted-foreground mr-1">{index + 1}.</span>}
            {t(`adminDashboard.hostedAgents.product.steps.${step.id}`)}
          </button>
        ))}
      </nav>
      <TabsList
        aria-label={t(`adminDashboard.hostedAgents.product.steps.${selected.id}`)}
        className="h-auto w-full flex-wrap justify-start"
      >
        {selected.tabs.map((tab) => (
          <TabsTrigger key={tab} className="min-h-10" value={tab}>
            {t(`adminDashboard.hostedAgents.editDialog.tabs.${tab}`)}
          </TabsTrigger>
        ))}
      </TabsList>
    </div>
  )
}
